var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('footer', {
    staticClass: "footer"
  }, [_c('v-container', [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', [_c('h1', {
    staticClass: "font-size-20 font-size-lg-32 line-height-14 ma-0"
  }, [_vm._v("KATA Auction")]), _c('div', {
    staticClass: "mt-20 mt-md-30"
  }, [_c('ul', {
    staticClass: "footer-link"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/location"
    }
  }, [_vm._v("LOCATION ")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/auction-policy"
    }
  }, [_vm._v("경매약관")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/service-policy"
    }
  }, [_vm._v("서비스이용약관")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/privacy-policy"
    }
  }, [_vm._v("개인정보처리방침")])], 1)])]), _c('div', {
    staticClass: "mt-16"
  }, [_c('ul', {
    staticClass: "footer-info"
  }, _vm._l(_vm.info, function (item) {
    return _c('li', {
      key: item._id
    }, [_c('span', [_vm._v(_vm._s(item.term))]), _vm._v(" " + _vm._s(item.desc) + " ")]);
  }), 0)]), _c('div', {
    staticClass: "mt-10"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_vm._v("Copyright ⓒ KATA Auction. All Rights Rerserved")])])]), _c('v-col', {
    staticClass: "d-flex flex-md-column",
    attrs: {
      "cols": "12",
      "md": "auto",
      "order": "first",
      "order-md": "last"
    }
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center",
      "align-md": "start"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', {
    staticClass: "d-inlie-block font-size-14 font-weight-medium mr-8"
  }, [_vm._v("SNS")])]), _vm._l(_vm.sns, function (_ref) {
    var _id = _ref._id,
        href = _ref.href,
        type = _ref.type;
    return _c('v-col', {
      key: _id,
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-btn', _vm._b({
      staticClass: "justify-center align-center line-height-0 mr-4",
      attrs: {
        "width": "24",
        "height": "24",
        "icon": "",
        "text": "",
        "target": "_blank"
      }
    }, 'v-btn', {
      href: href
    }, false), [type == 'twitter' ? _c('img', {
      attrs: {
        "src": "/images/icon/icon-twitter.png",
        "alt": "트위터"
      }
    }) : _vm._e(), type == 'facebook' ? _c('img', {
      attrs: {
        "src": "/images/icon/icon-facebook.png",
        "alt": "페이스북"
      }
    }) : _vm._e(), type == 'instagram' ? _c('img', {
      attrs: {
        "src": "/images/icon/icon-insta.png",
        "alt": "인스타"
      }
    }) : _vm._e()])], 1);
  })], 2), _c('u-scroll-top', {
    staticClass: "mt-md-auto ml-md-auto"
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }